import { useContext } from 'react';

import { assoc, drop, isEmpty, map, pipe } from 'ramda';

import { getEmergencyContactsBlocks } from '../../../../components/Pages/Admin/shared/PDFPreview/Pages/TripManifest/functions';
import { PDFDataContext } from '../../context';
import { IWithOnReady } from '../../types';
import { getPreparedPageBlocks } from '../OtherPages';
import Page from '../Page';

function EmergencyContactsPage({ onReady }: IWithOnReady) {
  const { page } = useContext(PDFDataContext);
  const pageJSON = page.landing.pages.find((p) => p.role === 'travel_brief');

  if (!pageJSON) {
    onReady();
    return null;
  }

  const { emergencyContactsBlocks } = getEmergencyContactsBlocks(
    pageJSON.blocks,
    // Drop 1st element (page header from V1 structure) and add pageTitle for the V2 PDF structure
    pipe(getPreparedPageBlocks, drop(1), map(assoc('pageTitle', 'Emergency Contacts'))),
  );

  if (isEmpty(emergencyContactsBlocks)) {
    onReady();
    return null;
  }

  return <Page blocks={emergencyContactsBlocks} onReady={onReady} />;
}

export default EmergencyContactsPage;
